// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDlnfuQY7Ng5mStdlKhF1uKMYfjRzYmepM",
  authDomain: "hadaf-71be3.firebaseapp.com",
  projectId: "hadaf-71be3",
  storageBucket: "hadaf-71be3.firebasestorage.app",
  messagingSenderId: "904554255968",
  appId: "1:904554255968:web:1fa120e2d6ae6e10e1d505",
  measurementId: "G-TEK72R7WQ3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app, { cookieFlags: "SameSite=None;Secure" });

export { app, analytics };
